/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../partials/containerTable";

export const getContainerUnitColumns = (t: any): Column[] => [
  {
    header: t('containerInventory.containerLotDetails.UnitIdentifier'),
    key: "serial_number",
    render: (row) => (
      <td className="px-10 py-3">
        <div className="flex flex-col">
          <span className="text-sm font-black text-[#2D3E50] tracking-tight">
            {row.serial_number}
          </span>
          <span className="text-[9px] uppercase tracking-widest text-slate-300">
            {row.container_type}
          </span>
        </div>
      </td>
    ),
  },

  {
    header: t('containerInventory.containerLotDetails.UsageLifecycle'),
    key: "lifecycle_count",
    render: (row) => {
      const usagePercentage =
        (Number(row.lifecycle_count) / Number(row.max_use_limit)) * 100;

      return (
        <td className="px-10 py-3">
          <div className="flex flex-col gap-2 min-w-[220px]">
            <div className="flex justify-between items-center">
              <span className="text-[11px] font-black text-slate-400 uppercase">
                {t('containerInventory.containerLotDetails.lifeCycle')}
              </span>

              <span className="text-[11px] font-black text-slate-600">
                {row.lifecycle_count}/{row.max_use_limit}
              </span>
            </div>

            <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
              <div
                className={`h-full ${
                  usagePercentage > 80
                    ? "bg-orange-500"
                    : usagePercentage > 0
                    ? "bg-emerald-500"
                    : "bg-blue-500"
                }`}
                style={{ width: `${usagePercentage}%` }}
              />
            </div>
          </div>
        </td>
      );
    },
  },

  {
    header: t('containerInventory.containerLotDetails.LastSterilization'),
    key: "last_sterilization_date",
    render: (row: any) => (
        <td className="px-10 py-8">
        <div className="flex items-center gap-3 px-4 py-2 bg-white border border-slate-200 rounded-xl w-fit shadow-sm">
            <span className="material-symbols-outlined text-orange-500 text-2xl">
            thermostat
            </span>

            <span className="text-[11px] font-black text-slate-700">
            {row.last_sterilization_date || "-"}
            </span>
        </div>
        </td>
    ),
    },

  {
    header: t('containerInventory.containerLotDetails.OperationalStatus'),
    key: "operational_status",
    render: (row: any) => {
        const status = row.operational_status;

        const dotColor =
        status === "STERILE"
            ? "bg-emerald-500 animate-pulse"
            : status === "NEAR_RETIREMENT"
            ? "bg-orange-500"
            : status === "EXPIRED"
            ? "bg-red-500"
            : "bg-blue-500";

        const textColor =
        status === "STERILE"
            ? "text-emerald-500"
            : status === "NEAR_RETIREMENT"
            ? "text-orange-500"
            : status === "EXPIRED"
            ? "text-red-500"
            : "text-blue-500";

        return (
        <td className="px-10 py-8">
            <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${dotColor}`} />

            <span
                className={`text-[10px] font-black uppercase tracking-widest ${textColor}`}
            >
                {status?.replaceAll("_", " ")}
            </span>
            </div>
        </td>
        );
    },
    },
];